import { render } from "./ui-file-input.vue?vue&type=template&id=dc17e094&ts=true"
import script from "./ui-file-input.vue?vue&type=script&lang=ts"
export * from "./ui-file-input.vue?vue&type=script&lang=ts"

import "./ui-file-input.vue?vue&type=style&index=0&id=dc17e094&lang=less&scope=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__